import { Component } from 'react';
import cx from 'classnames';

import { Router } from '../../configs/routes';
import styles from '../../styles/plan/summaryOverview.scss';
import { CDN_CLRSAVE_URL } from '../../constants';
import { trackAction } from '../../utils/trackActions';
import { Api } from '../../api';
import Loader from '../ui/Loader';
import { UserPersonalDetails } from '../../models/userdetails';
import { CartResponse } from '../../models/cart';

const api = new Api();

interface Props {
  onEdit?: () => void;
  hideEdit?: boolean;
  bankDetails: any;
}

interface State {
  cart: CartResponse;
  viewFunds: boolean;
  data: UserPersonalDetails;
}

class SummaryOverview extends Component<Props, State> {
  public state: State = {
    viewFunds: false,
    data: null,
    cart: null,
  };

  public async UNSAFE_componentWillMount() {
    Promise.all([api.getUserDetails(), api.getCart()]).then(
      ([userDetails, cartDetails]: any[]) => {
        this.setState({
          data: userDetails.response.entity.userPersonalDetails,
          cart: cartDetails.response,
        });
      }
    );
  }

  private onEdit = () => {
    trackAction('edit-funds', 'checkout-summary');
    if (this.props.onEdit) {
      this.props.onEdit();
    }
  };
  private onEditBankDetails = () => {
    Router.pushRoute(`${location.pathname}?detailsSlug=first`);
  };

  private showFunds = () => {
    this.setState({
      viewFunds: true,
    });
  };

  public render() {
    const { viewFunds, cart, data } = this.state;
    const { hideEdit, bankDetails } = this.props;
    const { nameOfBank, accountNo, ifscCode } = bankDetails;
    if (!data || !cart) {
      return <Loader size="40px" />;
    }
    const { fullName = '', pan = '' } = data;
    const investmentTypeText =
      cart.items[0].itemType === 'SIP_MF' ? 'Monthly SIP' : 'One Time';
    return (
      <div className={styles.summary}>
        <label className={cx('text--md block mb10')}>
          Hey <b>{fullName}</b> (PAN No. <b>{pan}</b>). You are almost done with
          your <b>{investmentTypeText}</b> investment of{' '}
          <b>Rs. {cart.totalAmount}</b>.
        </label>
        {!viewFunds && (
          <button className={styles['view-funds']} onClick={this.showFunds}>
            {`View Details >>`}
          </button>
        )}
        <div className={cx({ [styles.hide]: !viewFunds })}>
          <h6 className="text--xmd text--uppercase font--faded font--normal mb10">
            <span> Funds you will be investing in: </span>
            {!hideEdit ? (
              <button
                onClick={this.onEdit}
                className={cx(
                  'text--sm float--right text--uppercase',
                  styles.edit
                )}
              >
                Edit
              </button>
            ) : null}
          </h6>
          <ul className={styles.funds}>
            {cart &&
              cart.items &&
              cart.items.map((fund: any) => (
                <li
                  className={styles.fund}
                  key={fund.product.referProduct.fundName}
                >
                  <img
                    src={`${CDN_CLRSAVE_URL}/clearsave${fund.product.referProduct.imageUrl}`}
                    alt="bank"
                    className={styles.image}
                  />
                  <label
                    className={cx(
                      'inline-block text--md font--grey',
                      styles['fund-name']
                    )}
                  >
                    {fund.product.referProduct.fundName}
                  </label>
                </li>
              ))}
          </ul>
          <div className={cx('text--md block')}>
            <label className="mb20">
              On redemption of your investment, the amount would be credited
              into this bank account. Please confirm that this is your bank
              account.
            </label>
            <button
              onClick={this.onEditBankDetails}
              className={cx(
                'text--sm mt30 float--right text--uppercase',
                styles.edit
              )}
            >
              Edit
            </button>
            <h6 className="text--xmd text--uppercase font--faded font--normal mt10 mb10">
              Your Bank Details:
            </h6>
            <p className="text--sm">
              Bank Name : <b>{nameOfBank}</b>
              <br />
              Bank Account Number: <b>{accountNo}</b>
              <br />
              Bank IFSC Code : <b>{ifscCode}</b>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default SummaryOverview;



// WEBPACK FOOTER //
// ./components/plan/summaryOverview.tsx